import axios from 'axios';
const service = axios.create();
const http = (url, method, baseURL, headers = {}, options = {}) => {
  return (data) => {
    return service({
      baseURL,
      url,
      headers,
      method,
      data:
        method === 'post' || method === 'put' || method === 'delete'
          ? data
          : null,
      params:
        (method === 'get' ? data : null) ||
        (method === 'delete' ? data.query : null),
      ...options,
    })
      .then((response) => {
        console.log('response', response);
        if (response.data.code === 0) {
          return response.data?.data;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((err) => {
        console.log('request err', err);
        return err;
      });
  };
};

const httpGet = (url, baseURL, headers, options) => {
  return http(url, 'get', baseURL, headers, options);
};

const httpPost = (url, baseURL, headers, options) => {
  return http(url, 'post', baseURL, headers, options);
};

export default {
  get: httpGet,
  post: httpPost,
};
